/**
 * @generated SignedSource<<71e11ace28da07574118d95e38de6de1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type InfectoLeaveFeedbackInput = {
  body: string;
  clientMutationId?: string | null;
  nodeId?: string | null;
  screen?: string | null;
};
export type FeedbackPopup_LeaveFeedbackMutation$variables = {
  input: InfectoLeaveFeedbackInput;
};
export type FeedbackPopup_LeaveFeedbackMutation$data = {
  readonly FeedbackV2: {
    readonly infectoLeaveFeedback: {
      readonly clientMutationId: string | null;
    } | null;
  };
};
export type FeedbackPopup_LeaveFeedbackMutation = {
  response: FeedbackPopup_LeaveFeedbackMutation$data;
  variables: FeedbackPopup_LeaveFeedbackMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "FeedbackV2Mutations",
    "kind": "LinkedField",
    "name": "FeedbackV2",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "InfectoLeaveFeedbackPayload",
        "kind": "LinkedField",
        "name": "infectoLeaveFeedback",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "clientMutationId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FeedbackPopup_LeaveFeedbackMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FeedbackPopup_LeaveFeedbackMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c9dde685b8a3d3d8435cb92fa9e743f0",
    "id": null,
    "metadata": {},
    "name": "FeedbackPopup_LeaveFeedbackMutation",
    "operationKind": "mutation",
    "text": "mutation FeedbackPopup_LeaveFeedbackMutation(\n  $input: InfectoLeaveFeedbackInput!\n) {\n  FeedbackV2 {\n    infectoLeaveFeedback(input: $input) {\n      clientMutationId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cde78ce2d6215044c58ea6d9af6bf34a";

export default node;
